import { inject } from '@angular/core';
import { AuthService } from '@core/services';
import { environment } from '@envs/environment';
import { API_ENDPOINTS } from '@shared/constants';
import { BCUser, provideMessaging } from '@gozetta/z-messaging';

export const ZMessagingProvider = provideMessaging({
  platform: 'client',
  baseAPIUrl: environment.messagingUrl,
  stakeholdersApiUrl: environment.mainApiUrl,
  baseCollectionName: [...environment.firebaseCollectionName, 'messaging'],
  sendNewMessageAPI: `${API_ENDPOINTS.Messaging.SendMessage}`,
  mapId: environment.mapId,
  authUserFactory: () => inject(AuthService).currentUser() as unknown as BCUser,
  messageMaxLength: 1000,
  chatTabs: [
    {
      id: 'districts',
      label: 'Districts',
      collectionName: ['customers', 'conversations'],
      conversationListingAPI: `${API_ENDPOINTS.Messaging.GetAll}`,
      conversationUnreadFlag: 'unReadMessagesStakeHolderCount',
      stakeHolderType: 2,
    },
  ],
});
